import React from 'react'
import { checkPermission } from 'app/common/utils/helpers'
import { Button } from 'antd'
import CustomTextareaAutosize from '../components/CustomTextareaAutosize/CustomTextareaAutosize'
import { useFlags } from 'launchdarkly-react-client-sdk'
import TextareaAutosize from 'react-textarea-autosize'
import TemplateSuggestion from '../../../common/components/TemplateSuggestion'
import { useConversationApprovalPermission } from '@app/common/hooks'

function onKeyPress(e, onSubmit) {
  if (e.key === 'Enter') {
    e.preventDefault()
    onSubmit(null)
  }
}

export default function NewMessage(props) {
  /**
  NewMessage component renders UI for creating a message.

  UI includes a text area for the user to type the message body, and a Send button.

  It supports the edge case where a vendor does not yet exist on the Order, which replaces the Send button with an Add Vendor Note button.

  Should not be used with Unified Conversations. Instead, use the NewMessageTem component.
  */
  const {
    isSubmitting,
    orderData,
    onFocus,
    newMessageValue,
    handleInputChange,
    newMessageTitle,
    onSubmit,
    selectedTemplate,
    templates = [],
    onTemplateSelect,
    onViewAllTemplates,
    audienceFilter,
    isUnifiedConversation,
    isTemplateSuggestionEnabled,
  } = props

  const flags = useFlags() || {}
  const userCanApproveMessage = useConversationApprovalPermission()

  const assignmentMessageStatus = new Set(['pending_approval', 'waiting_for_payment'])
  const isVendorMessage = checkPermission('enable_current_vendor_message') && orderData && assignmentMessageStatus.has(orderData.statusKey)
  const onSubmitWrapper = () => {
    onSubmit({
      selectedTemplate,
    })
  }

  return (
    <main className='send-message' id='new-message'>
      <div className='w-100 mr-2'>
        {flags?.useUpdatedMessageTemplatesUx
          ? <TemplateSuggestion
            templates={templates}
            onTemplateSelect={onTemplateSelect}
            onViewAllTemplates={onViewAllTemplates}
            audienceFilter={audienceFilter}
            minCharacters={3}
            maxVisibleSuggestions={4}
            inputValue={newMessageValue}
            selectedTemplate={selectedTemplate}
            showPreApprovedOnly
            isUnifiedConversation={isUnifiedConversation}
            isEnabled={isTemplateSuggestionEnabled}
          >
            <CustomTextareaAutosize
              type='text'
              onKeyPress={(e) => onKeyPress(e, onSubmitWrapper)}
              onFocus={onFocus}
              value={newMessageValue}
              onChange={handleInputChange}
              className="form-control"
              placeholder="Type your message..."
              title={newMessageTitle}
              disabled={selectedTemplate?.is_pre_approved && !userCanApproveMessage}
              clearable
            />
          </TemplateSuggestion>
          : <TextareaAutosize
            type='text'
            onKeyPress={(e) => onKeyPress(e, onSubmitWrapper)}
            onFocus={onFocus}
            value={newMessageValue}
            onChange={handleInputChange}
            className="form-control"
            placeholder="Type your message..."
            title={newMessageTitle}
          />
        }
      </div>
      <div className='d-flex align-items-center'>
        <Button
          onClick={onSubmitWrapper}
          disabled={isSubmitting || newMessageValue === ''}
          type="primary"
          loading={isSubmitting}
        >
          { isVendorMessage ? 'Add Vendor Note' : 'Send' }
        </Button>
      </div>

    </main>)
}
